import { render, staticRenderFns } from "./AddCrewMember.vue?vue&type=template&id=5ec27fec"
import script from "./AddCrewMember.vue?vue&type=script&lang=js"
export * from "./AddCrewMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports